// src/features/imports/state/imports.initialState.ts

import type {
  ImportsReadModel,
  ImportsUiState,
  ImportsViewState,
  ImportsFeatureState,
} from '../model/imports.state.types'

export function createInitialUiState(
  readModel: ImportsReadModel,
): ImportsUiState {
  const selectedDriverImportIds = new Set<string>()
  const selectedVehicleImportIds = new Set<string>()

  for (const [id, item] of Object.entries(readModel.driverItemsById)) {
    if (item.bucket === 'existing') {
      selectedDriverImportIds.add(id)
    }
  }

  for (const [id, item] of Object.entries(readModel.vehicleItemsById)) {
    if (item.bucket === 'existing') {
      selectedVehicleImportIds.add(id)
    }
  }

  return {
    selectedDriverImportIds,
    selectedVehicleImportIds,

    driverDateFromByImportId: Object.fromEntries(
      Object.values(readModel.driverItemsById)
        .filter((d) => d.cooperationStartDate)
        .map((d) => [d.id, d.cooperationStartDate])
    ),
    driverAssignedToByImportId: {},
    vehicleAssignedToByImportId: {},

    removedDriverImportIds: new Set(),
    removedVehicleImportIds: new Set(),
  }
}

export function createInitialViewState(): ImportsViewState {
  return {
    driverSort: { key: 'fullName', direction: 'asc' },
    vehicleSort: { key: 'registrationNumber', direction: 'asc' },

    driverFilter: {
      bucket: 'all',
      fileId: 'all',
      onlySelected: false,
      search: '',
    },
    vehicleFilter: {
      bucket: 'all',
      fileId: 'all',
      onlySelected: false,
      search: '',
    },
  }
}

/**
 * Creates a full feature state object that you can store in a single useState/useReducer.
 */
export function createInitialFeatureState(
  readModel: ImportsReadModel,
): ImportsFeatureState {
  return {
    readModel,
    ui: createInitialUiState(readModel),
    view: createInitialViewState(),
  }
}
